import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { BackupService } from '../../services/backup.service';
import { FrontEndService } from "../../services/front-end.service";
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-backup-and-restore',
    templateUrl: './backup-and-restore.component.html',
    styleUrls: ['./backup-and-restore.component.scss'],
})
export class BackupAndRestoreComponent implements OnInit {

    @ViewChild('content') content: ElementRef;

    backupData = [];
    fullScreenLoader = false;
    files = [];

    backup_files_error = false;
    closeResult: string;
    public modalRef: NgbModalRef;

    constructor(
        private backupService: BackupService,
        public front_end_service: FrontEndService,
        private modalService: NgbModal,
    ) { }

    ngOnInit() {
        this.fullScreenLoader = true;
        this.backupList();
    }

    backupList() {
        this.backupService.backupList((resp) => {
            if(resp.status) {
                this.backupData = resp.data;
            }
            this.fullScreenLoader = false;
        });
    }

    createBackup() {
        this.fullScreenLoader = true;
        this.backupService.createBackup((resp) => {
            if (resp.status) {
                this.front_end_service.addToast(
                    "Success",
                    resp.message,
                    "success"
                );
            }
            this.fullScreenLoader = false;
            this.backupList();
        });
    }

    downloadBackup(backup_id, backup_name) {
        this.fullScreenLoader = true;
        this.backupService.downloadBackup(backup_id, (resp) => {
            this.fullScreenLoader = false;

        });
    }

    restoreBackup(backup_id) {
        this.fullScreenLoader = true;
        this.backupService.restoreBackup(backup_id, (resp) => {
            if(resp.status) {
                this.front_end_service.addToast(
                    "Success",
                    resp.message,
                    "success"
                );
            }
            this.fullScreenLoader = false;

        });
    }

    deleteBackup(backup_id) {
        this.fullScreenLoader = true;
        this.backupService.deleteBackup(backup_id, (resp) => {
            if (resp.status) {
                this.backupList();
                this.fullScreenLoader = false;
                this.front_end_service.addToast(
                    "Success",
                    resp.message,
                    "success"
                );
            }
        });
    }

    setFile(event) {
        this.files = event.srcElement.files;
    }

    uploadBackup(data) {
        data.backup_file = this.files;
        if(this.files.length <= 0) {
            this.backup_files_error = true;
        } else {
            this.backup_files_error = false;
            this.closeModal();
            this.fullScreenLoader = true;
            this.backupService.uploadBackup(data, (resp) => {
                if(resp.status === true) {
                    this.backupList();
                    this.front_end_service.addToast(
                        "Success",
                        resp.message,
                        "success"
                    );
                }
                this.fullScreenLoader = false;
            });
        }
    }

    open(content) {
        this.modalRef = this.modalService.open(content);
        this.modalRef.result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }

    closeModal() {
        this.modalRef.close();
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }
}
